import { Outlet, useSearchParams } from 'react-router-dom';
import { SidebarLayout } from '../../component-lib/catalyst/sidebar-layout';
import { useUserContext } from '../../context/UserContext';
import JFNavbar from './JFNavbar';
import JFSidebar from './JFSidebar';
import { usePendo } from '../../hooks/use-pendo';

export default function JFLayout({ children, tabpanel }) {
  usePendo();
  const { user, permissions, logoutUser } = useUserContext();
  const [searchParams] = useSearchParams();
  const hideSidebar = searchParams.get('navbars') === 'False';

  return (
    <SidebarLayout
      navbar={
        <JFNavbar
          user={user}
          permissions={permissions?.group}
          logoutUser={() => logoutUser()}
        />
      }
      sidebar={
        <JFSidebar
          user={user}
          permissions={permissions?.group}
          logoutUser={() => logoutUser()}
        />
      }
      fullWidth
      tabpanel={tabpanel}
      hideSidebar={hideSidebar}
    >
      {children}
      <Outlet />
    </SidebarLayout>
  );
}
